import { Affix, Button, Card, CloseButton, Title } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useEffect, useState } from "react";

import { RequestLog, requestMonitor } from "@/store/http/monitor";

type Position = "bottom_left" | "bottom_right" | "top_left" | "top_right";
type RequestMonitorPanelProps = {
  position?: Position;
  inset?: number | string;
  hide?: boolean;
};
export function RequestMonitorPanel({ position = "bottom_left", inset = 20, hide = true }: RequestMonitorPanelProps) {
  const [logs, setLogs] = useState<RequestLog[]>([]);
  // const [isOpen, setIsOpen] = useState(false);
  const [isOpen, { toggle }] = useDisclosure(false);

  const handleToggle = toggle;

  useEffect(() => {
    const unsubscribe = requestMonitor.subscribe(setLogs);
    return unsubscribe;
  }, []);

  const positions = new Map<Position, Partial<Record<"left" | "bottom" | "right" | "top", typeof inset>>>([
    [
      "bottom_left",
      {
        left: inset,
        bottom: inset
      }
    ],
    [
      "bottom_right",
      {
        right: inset,
        bottom: inset
      }
    ],
    [
      "top_left",
      {
        top: inset,
        left: inset
      }
    ],
    [
      "top_right",
      {
        top: inset,
        right: inset
      }
    ]
  ]);
  const currentPosition = positions.get(position);

  if (import.meta.env.MODE !== "development" || hide) return null;

  if (!isOpen) {
    return (
      <Affix {...currentPosition}>
        <Button onClick={handleToggle} size="compact-xl" color="blue" leftSection={"📡"}>
          {logs.length} Requisições
        </Button>
      </Affix>
    );
  }

  return (
    <Affix {...currentPosition}>
      <Card maw={600} mah={500} withBorder>
        <div className="flex items-center justify-between">
          <Title order={4}>Monitor de Requisições ({logs.length})</Title>

          <div className="flex items-center justify-center">
            <Button variant="transparent" c="blue" size="compact-md" onClick={() => requestMonitor.clearLogs()}>
              Limpar
            </Button>

            <CloseButton onClick={handleToggle} style={{ marginLeft: "10px" }} />
          </div>
        </div>
      </Card>

      <div style={{ overflowY: "auto", flex: 1 }}>
        {logs.map((log) => (
          <div
            key={log.id}
            style={{
              padding: "10px",
              borderBottom: "1px solid #eee",
              backgroundColor: log.success ? "#f0f9ff" : "#fef2f2"
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span style={{ fontWeight: "bold" }}>
                {log.method} {log.url}
              </span>
              <span style={{ color: log.success ? "green" : "red" }}>{log.status || "N/A"}</span>
            </div>
            <div style={{ fontSize: "12px", color: "#666", marginTop: "5px" }}>
              {log.timestamp} • {log.duration}ms
            </div>
            {log.error && <div style={{ fontSize: "12px", color: "red", marginTop: "5px" }}>Erro: {JSON.stringify(log.error)}</div>}
          </div>
        ))}
      </div>
    </Affix>
  );
}
